import React, { useEffect, useRef } from 'react';
import { Tooltip } from '@mui/material';
import { Checkbox } from '../Layout';
import InfoTooltip from '../InfoTooltip';
import { TitleH3, TitleSpan, gridItemStyle, checkboxStyle } from '../CreateDeviceContent/styles';
import i18n from '../../helpers/i18n';
import { getReceiptModeResetValues, hasConflictingFlags, isDeviceForReceiptEnabled } from '../../helpers/consts/deviceForReceiptHelpers';

function DeviceForReceiptFlag({ formik, deviceArchived, receiptCheckboxDisabled }) {
    const handleChange = (event) => {
        const checked = event.target.checked;

        if (checked) {
            formik.setValues({
                ...formik.values,
                ...getReceiptModeResetValues(),
                device_for_receipt_flag_multi: true,
            });
            return;
        }

        formik.setFieldValue('device_for_receipt_flag_multi', false);
    };

    return (
        <Tooltip title={receiptCheckboxDisabled ? i18n.t('pages.newDevice.deviceForReceiptClearOtherFlags') : ''} arrow>
            <div style={checkboxStyle}>
                <Checkbox
                    label={i18n.t('pages.newDevice.deviceForReceiptFlagMulti')}
                    checked={formik.values.device_for_receipt_flag_multi}
                    onChange={handleChange}
                    disabled={deviceArchived || receiptCheckboxDisabled}
                />
                <InfoTooltip tooltip={i18n.t('pages.newDevice.deviceForReceiptFlagMultiDescription')} />
            </div>
        </Tooltip>
    );
}

export default function DeviceForReceiptSection({ formik, deviceArchived, company, permissions }) {
    const { values, setFieldValue } = formik;
    const isMultiDevice = values.deviceType === 'ahgora_multi_device';

    const shouldHideSection =
        (values.collaboratorsType === 'by_employee' && (values.employees?.length ?? 0) > 1) ||
        (values.collaboratorsType === 'by_location' && (values.locations?.length ?? 0) > 0);

    const receiptCheckboxDisabled =
        !values.device_for_receipt_flag_multi && hasConflictingFlags(values);

    const prevShouldHideSectionRef = useRef(false);

    useEffect(() => {
        const didBecomeHidden = shouldHideSection && !prevShouldHideSectionRef.current;
        if (didBecomeHidden && values.device_for_receipt_flag_multi) {
            setFieldValue('device_for_receipt_flag_multi', false);
        }
        prevShouldHideSectionRef.current = shouldHideSection;
    }, [shouldHideSection, values.device_for_receipt_flag_multi, setFieldValue]);

    const conflictActive = hasConflictingFlags(values);

    useEffect(() => {
        if (!values.device_for_receipt_flag_multi || !conflictActive) {
            return;
        }
        const resets = getReceiptModeResetValues();
        Object.entries(resets).forEach(([field, fieldValue]) => {
            setFieldValue(field, fieldValue);
        });
        setFieldValue('device_for_receipt_flag_multi', true);
    }, [values.device_for_receipt_flag_multi, conflictActive, setFieldValue]);

    if (!isDeviceForReceiptEnabled(company) || !permissions?.repp) {
        return null;
    }

    if (!isMultiDevice || shouldHideSection) {
        return null;
    }

    return (
        <div style={gridItemStyle}>
            <div style={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
                <TitleH3>
                    {i18n.t('pages.newDevice.deviceForReceiptTitle')} <TitleSpan>{i18n.t('pages.newDevice.optional')}</TitleSpan>
                </TitleH3>
            </div>
            <DeviceForReceiptFlag
                formik={formik}
                deviceArchived={deviceArchived}
                receiptCheckboxDisabled={receiptCheckboxDisabled}
            />
        </div>
    );
}
